<ion-header class="ion-no-border" [translucent]="false">
  <ion-toolbar
    [color]="mobile() ? '' : 'secondary-detail'"
    [class.detail-page]="!mobile()"
  >
    <ion-buttons slot="start">
      @if (showCloseButton()) {
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
      }
      <ion-back-button [text]="originPage"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="openModal()">
        <ion-icon name="pencil-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="openMileageDialog()">
        <ion-icon
          [name]="
            lesson()?.StartMileage && lesson()?.EndMileage
              ? 'speedometer'
              : 'speedometer-outline'
          "
        ></ion-icon>
      </ion-button>
      <ion-button (click)="openMaps()">
        <ion-icon name="locate-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="presentDeleteActionSheet()">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding max-width-content">
@defer (when !androidFakeLoading()) { @if(lesson()) {
  <div [class.sm-padding-content]="!mobile()">
    <ion-list
      class="mt-4 transparent"
      [class.rounded-lg]="!mobile()"
      lines="none"
    >
      <ion-item class="transparent">
        <ion-label>
          <h1>{{ lesson().Subject }}</h1>
        </ion-label>
      </ion-item>
      <ion-item class="mb-3 transparent">
        <ion-row class="flex flex-col">
          <ion-label>
            <ion-note class="text-md">{{
              lesson().StartTime | date : "dd.MM.yyyy"
            }}</ion-note>
          </ion-label>
          <ion-label>
            <ion-note class="text-md"
              >{{ lesson().StartTime | date : "HH:mm" }} -
              {{ lesson().EndTime | date : "HH:mm" }} ({{
                lesson().Type
              }})</ion-note
            >
          </ion-label>
          @if (lesson().Location) {
          <ion-note class="flex items-center mt-4 mb-1">
            <ion-icon
              color="primary"
              name="location-outline"
              class="mr-2"
            ></ion-icon>
            <ion-text color="dark"
              ><a
                [href]="getGoogleMapsLink(lesson().Location)"
                class="text-md"
                >{{ lesson().Location }}</a
              ></ion-text
            >
          </ion-note>
          } @if (lesson().Description) {
          <ion-note class="flex items-center -my-2">
            <ion-icon
              color="primary"
              name="document-text-outline"
              class="mr-2"
            ></ion-icon>
            <ion-text color="dark"
              ><p class="text-md">{{ lesson().Description }}</p></ion-text
            >
          </ion-note>
          }
        </ion-row>
      </ion-item>
    </ion-list>
    <ion-grid class="button-grid">
      <ion-row>
        <ion-col>
          @if (lesson().Type === "Fahrstunde") {
          <ion-button
            fill="outline"
            class="w-full"
            (click)="openEducationCard()"
          >
            <div class="flex flex-col items-center">
              <ion-icon
                class="text-2xl"
                slot="icon-only"
                name="school"
              ></ion-icon>
              <span class="text-xs font-normal">Ausbildung</span>
            </div>
          </ion-button>
          } @if (lesson().Type === "Probeprüfung") {
          <ion-button
            [ngClass]="{
              'motion-preset-confetti': viewInit() && lesson().PassedTest,
              'motion-duration-1000': viewInit() && lesson().PassedTest
            }"
            fill="outline"
            class="w-full !m-1"
            [color]="
              lesson().PassedTest === true
                ? 'success'
                : lesson().PassedTest === false
                ? 'danger'
                : ''
            "
            (click)="openExamDialog()"
          >
            <div class="flex flex-col items-center">
              <ion-icon
                class="text-2xl"
                slot="icon-only"
                name="document-text"
              ></ion-icon>
              <span class="text-xs font-normal">Probeprüfung</span>
            </div>
          </ion-button>
          } @if (lesson().Type === "Prüfung") {
          <ion-button
            [ngClass]="{
              'motion-preset-confetti': viewInit() && lesson().PassedTest,
              'motion-duration-1000': viewInit() && lesson().PassedTest
            }"
            fill="outline"
            class="w-full !m-1"
            [color]="
              lesson().PassedTest === true
                ? 'success'
                : lesson().PassedTest === false
                ? 'danger'
                : ''
            "
            (click)="openExamDialog()"
          >
            <div class="flex flex-col items-center">
              <ion-icon
                class="text-2xl"
                slot="icon-only"
                name="document-text"
              ></ion-icon>
              <span class="text-xs font-normal">Prüfung</span>
            </div>
          </ion-button>
          }
        </ion-col>
        <ion-col>
          <ion-button fill="outline" class="w-full" (click)="contactStudent()">
            <div class="flex flex-col items-center">
              <ion-icon
                class="text-2xl"
                slot="icon-only"
                name="logo-whatsapp"
              ></ion-icon>
              <span class="text-xs font-normal">Kontaktieren</span>
            </div>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button
            fill="outline"
            [disabled]="invoiceSignal()"
            (click)="openNewInvoiceDialog()"
            [color]="invoiceSignal() ? 'success' : ''"
            class="w-full"
          >
            <div class="flex flex-col items-center">
              <ion-icon
                class="text-2xl"
                slot="icon-only"
                name="wallet"
              ></ion-icon>
              <span class="text-xs font-normal">{{
                invoiceSignal() ? "Verrechnet" : "Verrechnen"
              }}</span>
            </div>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    @if (invoiceSignal(); as invoice) {
    <ion-item-divider class="mt-6" mode="ios">
      <ion-label>Rechnung</ion-label>
    </ion-item-divider>
    <ion-list class="transparent">
      <ion-item
        button
        (click)="openInvoice(invoice)"
        detail="false"
        lines="none"
        color="tertiary"
        class="mt-4"
      >
        <app-invoice-item
          class="w-full p-2"
          [invoiceId]="invoice.invoice_id"
        ></app-invoice-item>
      </ion-item>
    </ion-list>
    } @if (oldLessons()?.length > 0) {
    <ion-item-divider mode="ios" class="mt-6">
      <div class="flex w-full justify-between">
        <ion-label>Vergangene Fahrstunden</ion-label>
        <div>
          {{ oldLessons().length }} ({{ calculateTotalTime(oldLessons()) }})
        </div>
      </div>
    </ion-item-divider>
    <ion-list color="dark" lines="none" class="mb-6 mt-4 rounded-lg">
      <ion-accordion-group mode="ios">
        <!-- order the appointments by start -->
        @for (lesson of oldLessons() | order: "StartTime"; track lesson) {
        <app-lesson-accordion
          [appointment]="lesson"
          [student]="studentSignal()"
          (newInvoiceClick)="openNewInvoiceDialog(lesson)"
          (openInvoiceClick)="openInvoice($event)"
        >
        </app-lesson-accordion>
        }
      </ion-accordion-group>
    </ion-list>
    }
  </div>
} } @if (androidFakeLoading()) {
  <div [class.sm-padding-content]="!mobile()">
    <ion-list
      class="mt-4 transparent"
      [class.rounded-lg]="!mobile()"
      lines="none"
    >
      <ion-item class="transparent">
        <ion-label>
          <ion-skeleton-text
            [animated]="true"
            style="width: 180px; height: 35px; border-radius: 0.25rem"
          ></ion-skeleton-text>
        </ion-label>
      </ion-item>
      <ion-item class="mb-3 transparent">
        <ion-row class="flex flex-col">
          <ion-label>
            <ion-skeleton-text
              [animated]="true"
              style="width: 60px; height: 10px; border-radius: 0.25rem"
            ></ion-skeleton-text>
          </ion-label>
          <ion-label>
            <ion-skeleton-text
              [animated]="true"
              style="width: 80px; height: 10px; border-radius: 0.25rem"
            ></ion-skeleton-text>
          </ion-label>
          <ion-note class="flex items-center mt-2 mb-1">
            <ion-skeleton-text
              [animated]="true"
              style="width: 150px; height: 12px; border-radius: 0.25rem"
            ></ion-skeleton-text>
          </ion-note>
        </ion-row>
      </ion-item>
    </ion-list>
    <ion-grid class="button-grid">
      <ion-row>
        <ion-col>
          <ion-skeleton-text
            [animated]="true"
            style="height: 60px; border-radius: 1rem"
          ></ion-skeleton-text>
        </ion-col>
        <ion-col>
          <ion-skeleton-text
            [animated]="true"
            style="height: 60px; border-radius: 1rem"
          ></ion-skeleton-text>
        </ion-col>
        <ion-col>
          <ion-skeleton-text
            [animated]="true"
            style="height: 60px; border-radius: 1rem"
          ></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
}
</ion-content>